module.exports = __webpack_public_path__ + "static/img/Slice 4@2x.96cee4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/Slice 4@2x.png
// module id = lihM
// module chunks = 1